import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Table from "../../../../core/common/dataTable/index";
import ApplicationTable from "./ApplicationTable";
import { getApplications } from "../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const PendingMIS = () => {
     const language = useSelector((state:any)=>state.auth.language);
    
     
          const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
      
      const statusOptions = [
        // {value: "all" , label:"All"},
          { value: "all_pending", label: "All Application" ,  role:["SEC","JC" , "COM" , "Dr" , "DY", "DT","SA"] },
          { value: "pendingAtApmcSecretary", label: "Pending with APMC Secretary" ,  role:["SEC","JC" , "COM" , "Dr" , "DY", "DT","SA"] },
          { value: "pendingAtClerk", label: "Pending with Junior Clerk" ,  role:["JC" , "COM" , "Dr" ,  "HJC" , "HOS" ,"SC", "DY", "DT","SA"] },
          { value: "pendingAtCo", label: "Pending With Cooperative Officer Marketing" , role:["COM" , "Dr" ,  "HJC" ,"SC", "HOS" , "DY", "DT","SA"]},
          { value: "pendingAtDr", label: "Pending with District Registrar", role:[ "Dr" ,  "HJC" ,"SC", "HOS" , "DY", "DT","SA"] },
          { value: "pendingAtApmcSecretaryResubmission", label: "Resubmission Pending with APMC Secretary" ,  role:["SEC","JC" , "COM" , "Dr" , "DY", "DT","SA"] },
        { value: "pendingAtClerkResubmission", label: "Resubmission Pending with Junior Clerk" ,  role:["JC" , "COM" , "Dr" ,  "HJC" ,"SC", "HOS" , "DY", "DT","SA"]},
        { value: "pendingAtCoResubmission", label: "Resubmission Pending with Cooperative Officer Marketing" ,  role:["COM" , "Dr" ,  "HJC" ,"SC", "HOS" , "DY", "DT","SA"] },
        { value: "pendingAtDrResubmission", label: "Resubmission Pending with District Registrar" , role:[ "Dr" ,  "HJC" ,"SC", "HOS" , "DY", "DT","SA"]  },
        // { value: "licenseGranted", label: "Approved Unsigned" },    
        // { value: "clerkAfterApproveAction", label: " Approved Application" }, 
        // { value: "clerkAfterRejectionAction", label: "Rejection Application" }, 
      ];

const roleDefaultPendingMap: Record<string, string> = {
  SEC: "pendingAtApmcSecretary",
  JC: "pendingAtClerk",
  COM: "pendingAtCo",
  Dr: "pendingAtDr",
};

     
      const filteredOptions = statusOptions.filter(option => option.role.includes(roleIdentifier));
      
const firstOptionValue =
  roleDefaultPendingMap[roleIdentifier] ||
  filteredOptions.find(o => !o.value.includes("all"))?.value ||
  filteredOptions[0]?.value;
      
      // Reorder the options to place the matched option first
const reorderedStatusOptions = [
  filteredOptions.find(option => option.value === firstOptionValue),
  ...filteredOptions.filter(option => option.value !== firstOptionValue),
].filter(Boolean);



    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{language.application_list}</h2>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Performance Indicator list */}
                    <div className="card">
                     

                        <div className="card-body p-0">
                            <ApplicationTable status={reorderedStatusOptions} navigateTo={"/>mis-raise-query"} />
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
            </div>
        </>
    );
};

export default PendingMIS;
